import { useState } from 'react';
import { useDungeonEditorStore } from '@/store/dungeonEditorStore';
import { DungeonOverviewPanel } from './panels/DungeonOverviewPanel';
import { RoomPanel } from './panels/RoomPanel';
import { EntityPanel } from './panels/EntityPanel';
import { TriggerPanel } from './panels/TriggerPanel';
import { QuestPanel } from './panels/QuestPanel';
import { QuestDesignerModal } from './modals/QuestDesignerModal';
import { TriggerGraphModal } from './modals/TriggerGraphModal';

type Tab = 'details' | 'quests' | 'triggers';

export function EditorPanel() {
  const [activeTab, setActiveTab] = useState<Tab>('details');
  const [showQuestDesigner, setShowQuestDesigner] = useState(false);
  const [showTriggerGraph, setShowTriggerGraph] = useState(false);

  const selectedRoomId = useDungeonEditorStore((s) => s.selectedRoomId);
  const selectedEntityId = useDungeonEditorStore((s) => s.selectedEntityId);
  const selectedTriggerId = useDungeonEditorStore((s) => s.selectedTriggerId);

  const tabClass = (tab: Tab) =>
    `flex-1 py-1.5 text-xs font-medium transition-colors ${
      activeTab === tab
        ? 'text-gray-100 border-b border-indigo-500'
        : 'text-gray-500 hover:text-gray-300 border-b border-transparent'
    }`;

  const renderDetailsContent = () => {
    if (selectedRoomId) return <RoomPanel />;
    if (selectedEntityId) return <EntityPanel />;
    if (selectedTriggerId) return <TriggerPanel />;
    return <DungeonOverviewPanel />;
  };

  return (
    <>
      <div className="w-[300px] bg-gray-900/50 border-l border-gray-800 flex flex-col">
        <div className="flex border-b border-gray-800 flex-shrink-0">
          <button className={tabClass('details')} onClick={() => setActiveTab('details')}>
            Details
          </button>
          <button className={tabClass('quests')} onClick={() => setActiveTab('quests')}>
            Quests
          </button>
          <button
            className={tabClass('triggers')}
            onClick={() => {
              setActiveTab('triggers');
              setShowTriggerGraph(true);
            }}
          >
            Triggers
          </button>
        </div>
        <div className="flex-1 p-3 overflow-y-auto">
          {activeTab === 'details' ? (
            renderDetailsContent()
          ) : (
            <QuestPanel onOpenDesigner={() => setShowQuestDesigner(true)} />
          )}
        </div>
      </div>

      {showQuestDesigner && (
        <QuestDesignerModal onClose={() => setShowQuestDesigner(false)} />
      )}

      {showTriggerGraph && (
        <TriggerGraphModal onClose={() => { setShowTriggerGraph(false); setActiveTab('details'); }} />
      )}
    </>
  );
}
